import store from '@/state/store'

export default [

  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: false,
    },
    component: () => {

      return import('./views/dashboards/default')

    
    }
  },




  // {
  //   path: '/customer-info',
  //   name: 'customer-info',
  //   meta: { authRequired: true },
  //   props(route) {
  //     return {customerId: (Number) (route.query.customerId) }
  //   },
  //   component: () => import('./views/admin/customer-info')
  // },

  // {
  //   path: '/profil',
  //   name: 'Gestion de Profile',
  //   meta: { authRequired: true },
  //   component: () => import('./views/account/profil')
  // },

  // {
  //   path: '/se-connecter',
  //   name: 'se-connecter',
  //   component: () => import('./views/account/login'),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters['auth/loggedIn']) {
  //         // Redirect to the home page instead
  //         next({ name: 'default' })
  //       } else {
  //         // Continue to the login page
  //         next()
  //       }
  //     },
  //   },
  // },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/')
        )

        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },




  // {
  //   path: '/banners',
  //   name: 'Admin Banners',
  //   meta: { authRequired: true },
  //   component: () => import('./views/admin/banners')
  // },

  // {
  //   path: '/bannieres',
  //   name: 'Bannières',
  //   meta: { authRequired: true },
  //   component: () => import('./views/banner-news/banners-news')
  // },

  // {
  //   path: '/utilisateurs',
  //   name: 'liste des utilisateurs',
  //   meta: { authRequired: true },
  //   component: () => import('./views/admin/listOfUsers')
  // },
  // {
  //   path: '/customer-utilisateurs',
  //   name: 'liste-des-utilisateurs',
  //   meta: { authRequired: true },
  //   props(route) {
  //     return {customerId: (Number) (route.query.id) }
  //   },
  //   component: () => import('./views/customer-admin/customerAdmin')
  // },
  {
    path: '/commandes',
    name: 'Commandes',
    meta: { authRequired: true },
    component: () => import('./views/order/orders')
  },
  {
    path: '/commandes/commande',
    name: 'Order',
    props(route) {
      return {  orderId: (Number) (route.query.orderId) }
    },
    meta: { authRequired: true },
    component: () => import('./views/order/order')
  },
  {
    path: '/sac-personnalise',
    name: 'catalogue',
    meta: { authRequired: false },
    component: () => import('./views/product/catalogue')
  },
  {
    path: '/sac-personnalise/:sectionName',
    name: 'catalogue du categorie',
    meta: { authRequired: false },
    component: () => import('./views/product/catalogue')
  },
  {
    path: '/sac-personnalise/:sectionName/:refItem-:ignored',
    name: 'Details Produit',
    meta: { authRequired: false },
    component: () => import('./views/product/product-details')
  },

  {
    path: '/concept-sacs-personnalisés',
    name: 'concept',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/concept')
  },
  // {
  //   path: '/tarifs-sacs-personnalisés',
  //   name: 'tarifs',
  //   meta: { authRequired: false },
  //   component: () => import('./views/dashboards/tarifs')
  // },
  {
    path: '/contacter-nous',
    name: 'contactUs',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/contact')
  },
  {
    path: '/demarrer-experience',
    name: ' Démarrer l\'expérience ',
    meta: { authRequired: false },
    component: () => import('./views/product/start-experiences')
  },

  {
    path: '/demarrer-experience/:sectionName',
    name: ' Démarrer l\'expérience categorie etape ',
    meta: { authRequired: false },
    component: () => import('./views/product/start-experiences')
  },
  {
    path: '/demarrer-experience/:sectionName/:refItem-:ignored',
    name: ' Démarrer l\'expérience article etape',
    meta: { authRequired: false },
    component: () => import('./views/product/start-experiences')
  },
  {
    path: '/personnalisation-produit/:code',
    name: 'Nos Produits',
    meta: { authRequired: false },
    component: () => import('./views/product/our-product')
  },

  {
    path: '/panier',
    name: 'cart',
    meta: { authRequired: false },
    component: () => import('../components/cartView')
  },

  {
    path: '/paiement',
    name: 'paiement',
    meta: { authRequired: false },
    props(route) {
      return {state: (String) (route.query.state) }
    },
    component: () => import('./views/order/paiement')
  },
  {
    path: '/commande/card/validee',
    name: 'ordertate',
    meta: { authRequired: false },
    props(route) {
      return {  order_s_ref: (String) (route.query.order_s_ref) ,
              orderId: (String) (route.query.orderId) }
    },
    component: () => import('./views/order/successPaiement')
  },

]
